import { render, staticRenderFns } from "./AttachmentsView.vue?vue&type=template&id=5bc4db34"
import script from "./AttachmentsView.vue?vue&type=script&lang=js"
export * from "./AttachmentsView.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsView.vue?vue&type=style&index=0&id=5bc4db34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports